<template>
  <div class="company-tag-header__company">
    <div class="company-tag-header__company-logo-container">
      <a-lazy-hydrate when-visible>
        <a-image
          :src="companyDetails.LogoUrl"
          alt="company-logo"
          :aspect-ratio="aspectRatios.flDirectoryCompanyLogo"
          class="company-tag-header__company-logo"
        />
      </a-lazy-hydrate>
    </div>

    <div class="company-tag-header__company-info-container">
      <h2 class="company-tag-header__company-name subtitle-3">
        {{ companyDetails.Name }}
      </h2>
      <a-show-more
        class="company-tag-header__description-wrapper"
        v-bind="descriptionProps"
      >
        <a-render-html
          :html="companyDescription"
          class="company-tag-header__description text-body"
        />
      </a-show-more>
    </div>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AShowMore from 'shared/AShowMore'
import { aspectRatios } from 'enums/aspectRatios'
import { processHtml } from '@/utils/helpers/processHtml'
import ARenderHtml from 'shared/ARenderHtml'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'CompanyTagHeader',
  mixins: [mixins.urlGenerators, hydrationHelpers],
  components: { ARenderHtml, AShowMore },
  props: {
    companyDetails: propValidator([PROP_TYPES.OBJECT])
  },
  data() {
    return { aspectRatios }
  },
  computed: {
    link() {
      return this.generateCompanyPath(this.companyDetails)
    },
    descriptionProps() {
      return {
        rowHeight: this.$_hydrationHelpers_mobileOrTabletOrDesktopValue(
          18,
          20,
          22
        ),
        rowCount: 4,
        to: this.link
      }
    },
    companyDescription() {
      return processHtml(this.companyDetails.Description)
    }
  }
}
</script>

<style lang="scss" scoped>
.company-tag-header__company {
  display: flex;

  @include tablet {
    flex-direction: column;
  }

  $logo-width: 162px;
  $logo-padding: 22px;

  .company-tag-header__company-logo-container {
    width: $logo-width;
    min-width: $logo-width;
    padding-right: $logo-padding;

    @include tablet {
      margin: 0 auto 20px auto;
      padding: 0;
    }
  }

  .company-tag-header__company-info-container {
    max-width: calc(100% - #{$logo-width + $logo-padding});
    flex-grow: 1;

    @include tablet {
      max-width: 100%;
    }
  }

  .company-tag-header__company-name {
    margin-bottom: 10px;
  }

  .company-tag-header__description-wrapper {
    display: block;
    max-width: 100%;
    margin-top: 20px;
  }

  .company-tag-header__description {
    max-width: 100%;

    /deep/ a {
      color: $c--main;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
